export const CUSTOMER_CLEAR_ELEMENTS = 'CUSTOMER_CLEAR_ELEMENTS';
export const CUSTOMER_CREATE = 'CUSTOMER_CREATE';
export const CUSTOMER_SET_ELEMENTS = 'CUSTOMER_SET_ELEMENTS';
export const CUSTOMER_SET_DETAILS = 'CUSTOMER_SET_DETAILS';
export const CUSTOMER_SET_LAST_PAGE = 'CUSTOMER_SET_LAST_PAGE';
export const CUSTOMER_SET_PAGE = 'CUSTOMER_SET_PAGE';